import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { isEmpty } from 'lodash';

import { Segment } from '@core/interfaces';
import { merge } from 'rxjs';

@Component({
  selector: 'tab-settings',
  templateUrl: './tab-settings.component.html',
  styleUrls: ['./tab-settings.component.scss']
})
export class TabSettingsComponent implements OnInit {

  @Input() isViewMode: boolean;
  @Input() maintenanceTypesForm: FormGroup;
  @Input() segment: Segment;

  @Output() noMaintenancesSelectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public segmentsSettingsForm: FormGroup;
  public noMaintenanceTypesSelected = false;
  public requiredMark = true;

  constructor(
    public fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.segmentsSettingsForm = this.fb.group({
      linkMaintenanceTypesToSegment: [false],
    });

    if (this.segment && !isEmpty(this.segment.maintenanceTypes)) {
      this.segmentsSettingsForm.controls.linkMaintenanceTypesToSegment.setValue(true);
    }

    merge(
      this.segmentsSettingsForm.get('linkMaintenanceTypesToSegment').valueChanges,
      this.maintenanceTypesForm.get('maintenanceTypes').valueChanges
    ).subscribe(() => {
      const linkMaintenanceTypesValue = this.segmentsSettingsForm.get('linkMaintenanceTypesToSegment').value;
      const maintenanceTypesValue = this.maintenanceTypesForm.get('maintenanceTypes').value;

      this.noMaintenanceTypesSelected = linkMaintenanceTypesValue && !maintenanceTypesValue;
      this.noMaintenancesSelectedChange.emit(this.noMaintenanceTypesSelected);
    });
  }
}
